import React from 'react';
import ReviewShowcase from '@/components/reviews/ReviewShowcase';

export default function GoogleReviewsStrip({topic,limit=3,heading='Selected patient testimonials',className=''}) {
  return <div className={`py-12 px-6 ${className}`}><div className="max-w-6xl mx-auto"><ReviewShowcase topic={topic} limit={limit} heading={heading} /></div></div>;
}
